export default __webpack_public_path__ + "static/media/sms.4598dcc6.svg";